import { DataModelBuilder, SerializationContext, SerializedData, DataModel } from '../../../../dto/data-model.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import { TicketTemplate } from '../../../ticket-template/ticket-template.js';
import { cloneData, isSameData } from '../../../../dto/data-model-utils.js';

export class SeatWithTicketTemplateDto extends DataModel {
  static readonly TYPE_ID = '61e18a43e24e46dba0e107127d79b384';

  private constructor(
    public readonly seatId: number,
    public readonly ticketTemplate: TicketTemplate,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatWithTicketTemplateDto.TYPE_ID;
  }

  static create(args: {
    seatId: number;
    ticketTemplate: TicketTemplate;
  }): SeatWithTicketTemplateDto {
    return new SeatWithTicketTemplateDto(args.seatId, args.ticketTemplate);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatWithTicketTemplateDto {
    return SeatWithTicketTemplateDto.create({
      seatId: MapUtils.getInteger(map, 'seatId'),
      ticketTemplate: context.fromData<TicketTemplate>(MapUtils.getRecord(map, 'ticketTemplate')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'seatId': this.seatId,
      'ticketTemplate': context.toData(this.ticketTemplate),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    seatId = this.seatId,
    ticketTemplate = cloneData(this.ticketTemplate),
  }: {
    seatId?: number;
    ticketTemplate?: TicketTemplate;
  } = {}): this {
    return SeatWithTicketTemplateDto.create({ seatId, ticketTemplate }) as this;
  }

  isSame(other: SeatWithTicketTemplateDto): boolean {
    return this === other || (
      this.seatId === other.seatId &&
      isSameData(this.ticketTemplate, other.ticketTemplate)
    );
  }
}

export class SeatWithTicketTemplateDtoBuilder extends DataModelBuilder<SeatWithTicketTemplateDto> {
  build(context: SerializationContext, map: SerializedData): SeatWithTicketTemplateDto {
    return SeatWithTicketTemplateDto.fromMap(context, map);
  }
}
